import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './FormPanels.scss';
/**
 * @component FormPanels
 * @since 1.0.0
 */
export function FormPanels(props) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const className = classNames('form-panels', 'form-panels--' + style, props.className);
    return React.createElement("div", { className: className }, props.children);
}
